module.exports = __webpack_public_path__ + "static/img/280_phase_function_Paper_Points.35fc584.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/280_phase_function_Paper_Points.png
// module id = 5+8D
// module chunks = 0